export default "__VITE_ASSET__bTTGlhUs__"